const values = [
  { icon: 'ri-heart-line', title: 'Family-Owned & Operated', desc: 'We\'re not a franchise — we\'re a family business rooted in Southern California with personal accountability on every single move.', color: 'text-rose-500', bg: 'bg-rose-50' },
  { icon: 'ri-shield-star-line', title: 'Fully Licensed & Insured', desc: 'Every move is protected. We carry comprehensive liability insurance and are fully licensed with the CPUC as a registered carrier.', color: 'text-emerald-500', bg: 'bg-emerald-50' },
  { icon: 'ri-user-heart-line', title: 'Customer-First Always', desc: 'We measure success by your satisfaction. Our team goes above and beyond — before, during, and after every move.', color: 'text-sky-500', bg: 'bg-sky-50' },
  { icon: 'ri-time-line', title: 'On-Time, Every Time', desc: 'We respect your schedule. Our crews arrive punctually, work efficiently, and communicate proactively if anything changes.', color: 'text-amber-500', bg: 'bg-amber-50' },
  { icon: 'ri-hand-coin-line', title: 'Transparent Pricing', desc: 'No hidden fees. No surprise charges. We provide clear, upfront estimates so you always know exactly what you\'re paying.', color: 'text-violet-500', bg: 'bg-violet-50' },
  { icon: 'ri-recycle-line', title: 'Eco-Conscious Moving', desc: 'We use reusable moving blankets and eco-friendly packing materials wherever possible to reduce waste on every job.', color: 'text-teal-500', bg: 'bg-teal-50' },
];

const promises = [
  { icon: 'ri-checkbox-circle-line', text: 'Your belongings treated with the same care as our own' },
  { icon: 'ri-checkbox-circle-line', text: 'Honest communication before, during, and after your move' },
  { icon: 'ri-checkbox-circle-line', text: 'No damage to floors, walls, or doorframes — guaranteed' },
  { icon: 'ri-checkbox-circle-line', text: 'Furniture placement exactly where you want it' },
  { icon: 'ri-checkbox-circle-line', text: 'Clean, organized trucks and professional equipment' },
  { icon: 'ri-checkbox-circle-line', text: 'Respectful, background-checked crew members' },
];

export default function AboutValues() {
  return (
    <>
      {/* Core Values */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <span className="inline-block bg-orange-100 text-orange-600 text-sm font-bold px-4 py-2 rounded-full mb-4">
              What We Stand For
            </span>
            <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-4">Our Core Values</h2>
            <p className="text-slate-600 max-w-2xl mx-auto text-lg">
              These principles guide every interaction, every move, and every decision we make as a company.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {values.map((v) => (
              <div key={v.title} className="bg-white rounded-2xl p-7 border border-gray-100 hover:-translate-y-1 transition-all duration-300">
                <div className={`w-12 h-12 flex items-center justify-center ${v.bg} rounded-xl mb-5`}>
                  <i className={`${v.icon} text-2xl ${v.color}`}></i>
                </div>
                <h3 className="text-lg font-black text-slate-900 mb-3">{v.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Promise */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/978ec997c49bcc5182de050fe70a0b2d.jpg"
                alt="City to City Moving Company crew carefully wrapping furniture"
                className="w-full rounded-3xl object-cover object-top"
                style={{ height: '440px' }}
              />
              <div className="absolute -top-5 -right-5 bg-white rounded-2xl p-5 border border-orange-100">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-orange-500 to-red-500 rounded-xl">
                    <i className="ri-award-line text-xl text-white"></i>
                  </div>
                  <div>
                    <div className="font-black text-slate-900">20+ Years</div>
                    <div className="text-slate-500 text-xs">In Business</div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <span className="inline-block bg-orange-100 text-orange-600 text-sm font-bold px-4 py-2 rounded-full mb-5">
                The City to City Promise
              </span>
              <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-5 leading-tight">
                What You Can Always Expect from Our Team
              </h2>
              <p className="text-slate-600 text-base leading-relaxed mb-7">
                Our reputation is built on trust. Every crew member we send to your home is trained, background-checked, and committed to the same high standards that have made us Southern California&apos;s most recommended moving company.
              </p>
              <ul className="space-y-3 mb-8">
                {promises.map((p) => (
                  <li key={p.text} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-orange-500 text-lg flex-shrink-0 mt-0.5"></i>
                    <span className="text-slate-700 text-sm font-medium">{p.text}</span>
                  </li>
                ))}
              </ul>
              <a href="tel:7606257767"
                className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-red-500 text-white px-7 py-3.5 rounded-xl font-bold hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap">
                <i className="ri-phone-fill"></i>Schedule Your Move
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
